module.exports = __webpack_public_path__ + "img/60.6.CODm.61658fef.png";